/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from '@carbon/react/icons';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';

var ExpandIcon = function ExpandIcon(_ref) {
  var isExpanded = _ref.isExpanded,
    overrideTranslations = _ref.overrideTranslations;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var className = classnames({
    'cds--list-box__menu-icon': true,
    'cds--list-box__menu-icon--open': isExpanded
  });
  var description = isExpanded ? (overrideTranslations === null || overrideTranslations === void 0 ? void 0 : overrideTranslations('collapse.group')) || t('Collapse group') : (overrideTranslations === null || overrideTranslations === void 0 ? void 0 : overrideTranslations('expand.group')) || t('Expand group');
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ChevronDown, {
    name: "chevron--down",
    "aria-label": description
  }, /*#__PURE__*/React.createElement("title", null, description)));
};
ExpandIcon.propTypes = {
  /**
   * Specify whether the group is currently expanded, which will influence the
   * direction of the icon
   */
  isExpanded: PropTypes.bool.isRequired,
  /**
   * i18n hook used to provide the appropriate description for the given
   * icon. This function takes in an id and should
   * return a string message for that given message id.
   */
  overrideTranslations: PropTypes.func
};
ExpandIcon.defaultProps = {
  overrideTranslations: undefined
};
var ExpandIcon$1 = ExpandIcon;

export { ExpandIcon$1 as default };
